// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import "babel-polyfill";
import promise from "es6-promise";
promise.polyfill();

import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

// import Nim from 'nim-web-sdk-ng'
// Vue.prototype.NIM = Nim.NIM;
import { i18n, translate } from "./common/lang/vue-i18n";
Vue.prototype.$ts = translate;

import ElementUI from "element-ui";
// import MyDatePicker from '@/components/date-picker'//自定义element ui date-picker
// Vue.use(MyDatePicker)

import "element-ui/lib/theme-chalk/index.css";
// import locale from "element-ui/lib/locale/lang/en";

import App from "./App";
import router from "./router";
import "../static/css/base.css"; //公共样式

import VueCookie from "vue-cookie";
Vue.use(VueCookie);

/* 解决360浏览器下backspace会返回上一页 */
import { banBackSpace } from "@/common/preventBackspace";
Vue.prototype.$banBackSpace = banBackSpace;

import store from "@/store"; //Vuex
Vue.prototype.$store = store;

import { post, get } from "@/api/axiosConfig";
Vue.prototype.$get = get;
Vue.prototype.$post = post;

Vue.config.productionTip = false;

// Vue.use(ElementUI, {
//   locale
// });
Vue.use(ElementUI);
router.beforeEach((to, from, next) => {
  // console.log("name", to.query);
  /* 开启验证 */
  store.state.UserToken = false;
  store.dispatch("checkUserToken");
  if (["Upload"].indexOf(to.name) > -1) {
    next();
  }
  else if (["Login", "Register", "Forgot"].indexOf(to.name) == -1) {
    var isSeller = to.query.isSeller ? to.query.isSeller : null;
    // console.log(to.query);
    store.dispatch("checkUser", { isSeller }).then(res => {
      if (res) {
        store.dispatch("checkExchange"); //汇率
        if (from.name) {
          store.dispatch("setPageSource", from.name);
        }
        store.state.pageIs = to.name;
        //console.log(from.name, to.name);
        /* 路由发生变化修改页面title */
        document.title = to.meta.title
          ? to.meta.title
          : "Seller Center - Card Hobby";
        // console.log(2);
        next();
      } else {
        // console.log(3);
        next({
          path: "/login"
        });
      }
    });
  } else {
    // console.log(4);
    store.dispatch("checkUser").then(res => {
      if (res) {
        if (!store.state.test) {
          /*login、Forgot页面用户已登录跳转首页*/
          next({
            path: "/"
          });
        } else {
          next();
        }
      } else {
        // console.log(3);
        next();
      }
    });
  }
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js